import {getIdToken} from "../../misc/miscUtils.ts";
import {URL_BASE} from "../../../Globals.ts";

export const deleteEmbeddings = async (user: any, projectName: string) => {
    if (!user) return;

    try {
        const token = await getIdToken(user);
        const url = `${URL_BASE}/api/deleteEmbeddings`;

        await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                projectName: projectName
            })
        });
    } catch (error) {
        console.error(`Error deleting embeddings: ${error}`);
    }
};
